import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { pinLogin, getDeviceRestaurant, clearDeviceSession, isDeviceMode } from "../services/api";

// Full-screen PIN lock for a shared tablet. Waiters/chefs tap their 4-char
// code to start their shift; the device session stays, only the person changes.
export default function DeviceLockPage() {
  const nav = useNavigate();
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const rest = getDeviceRestaurant();

  // If this tablet isn't a shared device, there's nothing to unlock.
  if (!isDeviceMode()) {
    nav("/login", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    if (pin.length !== 4) { setErr("Enter your 4-character code."); return; }
    setBusy(true); setErr("");
    try {
      await pinLogin(pin);
      nav("/", { replace: true });
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Wrong code. Try again.");
      setPin("");
    } finally { setBusy(false); }
  };

  const exit = () => {
    if (window.confirm("Exit shared-device mode on this tablet? A manager will need to set it up again.")) {
      clearDeviceSession();
      nav("/login", { replace: true });
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#063B48", padding: 24 }}>
      <form onSubmit={submit} style={{ width: "100%", maxWidth: 360, textAlign: "center", color: "#fff" }}>
        <div style={{ width: 64, height: 64, borderRadius: 18, background: "#008080", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
          <span style={{ width: 22, height: 22, borderRadius: 6, background: "#D4AF37", display: "block" }} />
        </div>
        <h1 style={{ fontSize: 22, margin: "0 0 4px" }}>{rest?.name || "ODRA"}</h1>
        <p style={{ color: "#cfe0e4", marginTop: 0, marginBottom: 20, fontSize: 14 }}>Enter your code to start your shift</p>
        <input
          autoFocus
          value={pin}
          onChange={(e) => setPin(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 4))}
          maxLength={4}
          inputMode="text"
          autoComplete="off"
          aria-label="Quick code"
          style={{ width: "100%", boxSizing: "border-box", fontSize: 34, letterSpacing: 14, textAlign: "center", padding: "14px 0", borderRadius: 12, border: "none", textTransform: "uppercase", fontWeight: 700, color: "#063B48" }}
          placeholder="••••"
        />
        {err && <div style={{ color: "#ffd2d2", marginTop: 12, fontSize: 14 }}>{err}</div>}
        <button type="submit" disabled={busy} style={{ marginTop: 18, width: "100%", background: "#D4AF37", color: "#063B48", border: "none", borderRadius: 10, padding: "14px", fontSize: 16, fontWeight: 700, cursor: "pointer", opacity: busy ? 0.7 : 1 }}>
          {busy ? "…" : "Start"}
        </button>
        <button type="button" onClick={exit} style={{ marginTop: 14, background: "none", border: "none", color: "#9fb8be", fontSize: 13, cursor: "pointer", textDecoration: "underline" }}>
          Exit shared-device mode
        </button>
      </form>
    </div>
  );
}
